// ═══════════════════════════════════════════════════════════════════
//  modules/documents/MerchModule.js
//  MerchModule
// ═══════════════════════════════════════════════════════════════════

import { useState } from "react";
import { CrudHeader } from "../../composants/CrudHeader";
import { CrudModal } from "../../composants/CrudModal";
import { DataTable } from "../../composants/DataTable";
import { fmtEur } from "../../socle/format";
import { useCrud } from "../../socle/hooks";
import { THEME } from "../../socle/theme";

// ═══════════════ 6) CATALOGUE MERCH ═══════════════
export function MerchModule({ token, onBack }) {
  const { items, loading, create, update, remove } = useCrud(token, "/api/documents/merch");
  const [edit,setEdit]=useState(undefined);
  const fields=[
    {key:"produit",label:"Produit",full:true,placeholder:"Peluche Boux"},
    {key:"fournisseur",label:"Fournisseur"},
    {key:"cout",label:"Coût (€)",type:"number",numeric:true},
    {key:"prix_vente",label:"Prix de vente (€)",type:"number",numeric:true},
    {key:"stock",label:"Stock",type:"number",numeric:true},
  ];
  const cols=[
    {key:"produit",label:"Produit",width:"1fr",render:(r)=><span style={{fontWeight:600}}>{r.produit}</span>},
    {key:"fournisseur",label:"Fournisseur",width:"1fr",render:(r)=><span style={{color:THEME.textMuted}}>{r.fournisseur||"—"}</span>},
    {key:"cout",label:"Coût",width:"90px",align:"right",render:(r)=>fmtEur(r.cout)},
    {key:"prix_vente",label:"Vente",width:"90px",align:"right",render:(r)=>fmtEur(r.prix_vente)},
    {key:"marge",label:"Marge",width:"90px",align:"right",render:(r)=><span style={{color:Number(r.marge)>=0?THEME.emerald:THEME.red,fontWeight:700}}>{fmtEur(r.marge)}</span>},
    {key:"stock",label:"Stock",width:"70px",align:"right"},
  ];
  return (
    <div style={{display:"flex",flexDirection:"column",gap:16}}>
      <CrudHeader onBack={onBack} title="🧸 Catalogue merch" onAdd={()=>setEdit(null)} addLabel="+ Produit" />
      <div style={{color:THEME.textDim,fontSize:12}}>La marge est calculée automatiquement (prix de vente − coût).</div>
      {loading ? <div style={{color:THEME.textMuted,padding:20}}>Chargement…</div> :
        <DataTable columns={cols} rows={items} onEdit={setEdit} onDelete={(id)=>{if(window.confirm("Supprimer ce produit ?"))remove(id);}} empty="Aucun produit au catalogue." />}
      {edit!==undefined && <CrudModal title={edit?"Éditer le produit":"Nouveau produit"} fields={fields} initial={edit} onClose={()=>setEdit(undefined)} onSave={async(b)=>{ edit?await update(edit.id,b):await create(b); setEdit(undefined); }} />}
    </div>
  );
}
